import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import CanvasJSReact from '../../canvasjs.react';
import Firebase from '../Firebase';
import Qestions1 from '../../Data/Qestions1.json';
import ReactExport from "react-export-excel";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
class Result extends Component {

    render() {
        return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div className="data_center">
                    <p style={{ textAlign: 'center', fontSize: 26 }}>
                        <strong>
                            แบบสอบถาม
                        <br></br>
                        โครงการโรงเรียนยุติธรรมอุปถัมภ์
                    <br></br>
                        สำนักงานกิจการยุติธรรม
                    <br></br>
                        (สำหรับนักเรียนที่เข้าร่วมกิจกรรม)
                    </strong>
                    </p>
                    <br></br>
                    <hr style={{ width: '90%' }}></hr>
                    <Data></Data>
                    <div>
                        <br></br>
                        <p>ติดต่อผู้พัฒนา email:adison.ra.56@ubu.ac.th  line-ID:oqiew2537</p>
                    </div>
                </div>
            </div>
        )
    }
}

export class Data extends Component {
    constructor(props) {
        super(props);

        this.state = {
            step: 1,
            step2: 1,
            students: [],
            teachers: [],
            boards: [],
            title_selected: '',

            //show data
            data_st_1: [],
            data_st_2: [],
            data_st_3: [],

            sSex: [],
            sAge: [],
            sLevel: [],
            sJoin: [],
            sJoin_number: [],
            scount: '',
            scount_join: '',
            options2: [],
            title1: 0,
            title2: 0,
            title3: 0,
            stdtitle1: 0,
            stdtitle2: 0,
            stdtitle3: 0,

            gdata21: '',
            gdata22: '',
            gdata23: '',
            result22: {
                gdata: '',
                av: '',
                std: '',
            }


        }
    }
    componentDidMount() {
        Firebase.firestore().collection('MOJ1S').onSnapshot(this.listdata);
    }
    listdata = (querySnapshot) => {

        const students = [];
        const teachers = [];
        const boards = [];
        const sSex = [0, 0];
        const sAge = [0, 0, 0, 0];
        const sLevel = [0, 0, 0, 0];
        const sJoin = [0, 0];
        const sJoin_number = [0, 0, 0];
        const data_st_1 = [0, 0, 0, 0];
        const data_st_2 = [[0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0]
            , [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0]];
        const data_st_3 = [0, 0, 0, 0]
        const options2 = [];

        querySnapshot.forEach((doc, i) => {
            const { rule } = doc.data()
            if (rule === 'นักเรียน') {
                const { School_name, Sex, Age, Level, Join, Join_number, Answer1, Answer2, Answer3, Score1, Score3 } = doc.data();

                if (Sex === 'ชาย') {
                    sSex[0] += 1;
                } else {
                    sSex[1] += 1;
                }
                if (Age === '7 - 9 ปี') {
                    sAge[0] += 1;
                } else if (Age === '10 - 12 ปี') {
                    sAge[1] += 1;
                } else if (Age === '13 - 15 ปี') {
                    sAge[2] += 1;
                } else {
                    sAge[3] += 1;
                }
                if (Level === 'ประถมศึกษาปีที่ 1 – 3') {
                    sLevel[0] += 1;
                } else if (Level === 'ประถมศึกษาปีที่ 4 – 6') {
                    sLevel[1] += 1;
                } else if (Level === 'มัธยมศึกษาปีที่ 1 – 3') {
                    sLevel[2] += 1;
                } else {
                    sLevel[3] += 1;
                }
                if (Join === 'เคย') {
                    sJoin[0] += 1;
                    if (Join_number === '1 ครั้ง') {
                        sJoin_number[0] += 1;
                    } else if (Join_number === '2 – 3 ครั้ง') {
                        sJoin_number[1] += 1;
                    } else {
                        sJoin_number[2] += 1;
                    }
                } else {
                    sJoin[1] += 1;
                }
                //data1
                if (Score1 >= 10) {
                    data_st_1[0] += 1;
                } else if (Score1 >= 7) {
                    data_st_1[1] += 1;
                } else if (Score1 >= 4) {
                    data_st_1[2] += 1;
                } else {
                    data_st_1[3] += 1;
                }
                //data2
                for (let index = 0; index < 15; index++) {
                    // console.log("ข้อที่",index,"ตอบ",Answer2[index])
                    data_st_2[index][parseInt(Answer2[index], 10)] += 1;
                }
                //data3
                if (Score3 >= 10) {
                    data_st_3[0] += 1;
                } else if (Score3 >= 7) {
                    data_st_3[1] += 1;
                } else if (Score3 >= 4) {
                    data_st_3[2] += 1;
                } else {
                    data_st_3[3] += 1;
                }

                students.push({
                    School_name, Sex, Age, Level, Join, Join_number, Score1, Score3
                })
            } else if (rule === 'ครู') {
                const { QName, QLast_name, QDate, QTime, QLocation, AName, ALast_name, AStatus,
                    ADetail, Answer1, Answer2, Answer3, Answer4 } = doc.data();
                teachers.push({
                    QName, QLast_name, QDate: new Date(QDate.seconds * 1000), QTime, QLocation, AName, ALast_name, AStatus,
                    ADetail, Answer1, Answer2, Answer3, Answer4
                })
            } else {
                const { QName, QLast_name, QDate, QTime, QLocation, AName, ALast_name, AStatus, ADetail, Answer1, Answer2, Answer3, Answer4 } = doc.data();
                // console.log(doc.data());
                boards.push({
                    QName, QLast_name, QDate: new Date(QDate.seconds * 1000), QTime, QLocation, AName, ALast_name, AStatus,
                    ADetail, Answer1, Answer2, Answer3, Answer4,
                })
            }

        })
        // console.log(data_st_2)
        const scount = students.length;


        var gn = 513 * 5;
        var n = 513;
        var countex = 0;
        var countex2 = 0;
        var count_gdata21 = 0;
        var count_gdata22 = 0;
        var count_gdata23 = 0;
        var count_gdata24 = 0;
        var count_gdata25 = 0;
        var count221 = 0;
        var count222 = 0;
        var count223 = 0;
        var count224 = 0;
        var count225 = 0;
        var result22_ex = 0;
        var result22_ex2 = 0;

        data_st_2.forEach((d, j) => {
            var gdata2 = '';

            count_gdata21 += (parseInt(d[1], 10));
            count_gdata22 += (parseInt(d[2], 10));
            count_gdata23 += (parseInt(d[3], 10));
            count_gdata24 += (parseInt(d[4], 10));
            count_gdata25 += (parseInt(d[5], 10));
            count221 += (parseInt(d[1], 10));
            count222 += (parseInt(d[2], 10));
            count223 += (parseInt(d[3], 10));
            count224 += (parseInt(d[4], 10));
            count225 += (parseInt(d[5], 10));
            var ex = (parseInt(d[5], 10) * 5) + (parseInt(d[4], 10) * 4) + (parseInt(d[3], 10) * 3) + (parseInt(d[2], 10) * 2) + (parseInt(d[1], 10) * 1);
            result22_ex += ex;
            var ex2 = (parseInt(d[5], 10) * 25) + (parseInt(d[4], 10) * 16) +
                (parseInt(d[3], 10) * 9) + (parseInt(d[2], 10) * 4) + (parseInt(d[1], 10) * 1);
            result22_ex2 += ex2;
            // var ex22 = Math.pow(ex, 2);
            countex += ex;
            countex2 += ex2;
            var av = ex / n;
            var std = Math.sqrt((ex2 / n) - (av * av));
            // console.log(ex, ex2, ex22, n, std);
            if (j == 4) {
                var t_av = countex / gn;
                var av2 = t_av.toFixed(2);
                var t_std = Math.sqrt((countex2 / gn) - (t_av * t_av));
                var std2 = t_std.toFixed(2);
                console.log(count_gdata25)
                gdata2 = {
                    animationEnabled: true,
                    exportEnabled: true,
                    theme: "light1", // "light1", "dark1", "dark2"
                    data: [{
                        type: "pie",
                        indexLabel: "{label}: {y}%",
                        // startAngle: -10 ,
                        dataPoints: [
                            { y: (count_gdata25 * 100 / (scount * 5)).toFixed(2), label: 'มากที่สุด' },
                            { y: (count_gdata24 * 100 / (scount * 5)).toFixed(2), label: 'มาก' },
                            { y: (count_gdata23 * 100 / (scount * 5)).toFixed(2), label: 'พอใช้' },
                            { y: (count_gdata22 * 100 / (scount * 5)).toFixed(2), label: 'น้อย' },
                            { y: (count_gdata21 * 100 / (scount * 5)).toFixed(2), label: 'น้อยที่สุด' }
                        ]
                    }]
                }

                this.setState({
                    title1: av2,
                    stdtitle1: std2,
                    gdata21: gdata2,
                })
                countex = 0;
                countex2 = 0;
                count_gdata21 = 0;
                count_gdata22 = 0;
                count_gdata23 = 0;
                count_gdata24 = 0;
                count_gdata25 = 0;

            } else if (j == 9) {
                var t_av = countex / gn;
                var av2 = t_av.toFixed(2);
                var t_std = Math.sqrt((countex2 / gn) - (t_av * t_av));
                var std2 = t_std.toFixed(2);
                gdata2 = {
                    animationEnabled: true,
                    exportEnabled: true,
                    theme: "light1", // "light1", "dark1", "dark2"
                    data: [{
                        type: "pie",
                        indexLabel: "{label}: {y}%",
                        // startAngle: -10 ,
                        dataPoints: [
                            { y: (count_gdata25 * 100 / (scount * 5)).toFixed(2), label: 'มากที่สุด' },
                            { y: (count_gdata24 * 100 / (scount * 5)).toFixed(2), label: 'มาก' },
                            { y: (count_gdata23 * 100 / (scount * 5)).toFixed(2), label: 'พอใช้' },
                            { y: (count_gdata22 * 100 / (scount * 5)).toFixed(2), label: 'น้อย' },
                            { y: (count_gdata21 * 100 / (scount * 5)).toFixed(2), label: 'น้อยที่สุด' }
                        ]
                    }]
                }
                this.setState({
                    title2: av2,
                    stdtitle2: std2,
                    gdata22: gdata2
                })
                countex = 0;
                countex2 = 0;
                count_gdata21 = 0;
                count_gdata22 = 0;
                count_gdata23 = 0;
                count_gdata24 = 0;
                count_gdata25 = 0;

            } else if (j == 14) {
                var t_av = countex / gn;
                var av2 = t_av.toFixed(2);
                var t_std = Math.sqrt((countex2 / gn) - (t_av * t_av));
                var std2 = t_std.toFixed(2);
                gdata2 = {
                    animationEnabled: true,
                    exportEnabled: true,
                    theme: "light1", // "light1", "dark1", "dark2"
                    data: [{
                        type: "pie",
                        indexLabel: "{label}: {y}%",
                        // startAngle: -10 ,
                        dataPoints: [
                            { y: (count_gdata25 * 100 / (scount * 5)).toFixed(2), label: 'มากที่สุด' },
                            { y: (count_gdata24 * 100 / (scount * 5)).toFixed(2), label: 'มาก' },
                            { y: (count_gdata23 * 100 / (scount * 5)).toFixed(2), label: 'พอใช้' },
                            { y: (count_gdata22 * 100 / (scount * 5)).toFixed(2), label: 'น้อย' },
                            { y: (count_gdata21 * 100 / (scount * 5)).toFixed(2), label: 'น้อยที่สุด' }
                        ]
                    }]
                }

                var temp_av_result22 = result22_ex / (513 * 15);
                var temp_std_result22 = Math.sqrt((result22_ex2 / (513 * 15)) - (temp_av_result22 * temp_av_result22));

                this.setState({
                    title3: av2,
                    stdtitle3: std2,
                    gdata23: gdata2,
                    result22: {
                        gdata: {
                            animationEnabled: true,
                            exportEnabled: true,
                            theme: "light1", // "light1", "dark1", "dark2"
                            data: [{
                                type: "pie",
                                indexLabel: "{label}: {y}%",
                                // startAngle: -10 ,
                                dataPoints: [
                                    { y: (count225 * 100 / (scount * 15)).toFixed(2), label: 'มากที่สุด' },
                                    { y: (count224 * 100 / (scount * 15)).toFixed(2), label: 'มาก' },
                                    { y: (count223 * 100 / (scount * 15)).toFixed(2), label: 'พอใช้' },
                                    { y: (count222 * 100 / (scount * 15)).toFixed(2), label: 'น้อย' },
                                    { y: (count221 * 100 / (scount * 15)).toFixed(2), label: 'น้อยที่สุด' }
                                ]
                            }]
                        }, av: temp_av_result22.toFixed(2),
                        std: temp_std_result22.toFixed(2),
                    }
                })
                countex = 0;
                countex2 = 0;
                count_gdata21 = 0;
                count_gdata22 = 0;
                count_gdata23 = 0;
                count_gdata24 = 0;
                count_gdata25 = 0;

            }
            // console.log(gdata2)
            options2.push({
                gdata: {
                    animationEnabled: true,
                    exportEnabled: true,
                    theme: "light1", // "light1", "dark1", "dark2"
                    title: {
                        text: Qestions1.Q2[j].Number + "." + Qestions1.Q2[j].Detail,
                        fontSize: 20
                    },
                    data: [{
                        type: "pie",
                        indexLabel: "{label}: {y}%",
                        // startAngle: -10 ,
                        dataPoints: [
                            { y: (parseInt(d[5], 10) * 100 / scount).toFixed(2), label: 'มากที่สุด' },
                            { y: (parseInt(d[4], 10) * 100 / scount).toFixed(2), label: 'มาก' },
                            { y: (parseInt(d[3], 10) * 100 / scount).toFixed(2), label: 'พอใช้' },
                            { y: (parseInt(d[2], 10) * 100 / scount).toFixed(2), label: 'น้อย' },
                            { y: (parseInt(d[1], 10) * 100 / scount).toFixed(2), label: 'น้อยที่สุด' }
                        ]
                    }]
                },
                data: {
                    av: av.toFixed(2),
                    std: std.toFixed(2)
                }, gdata2



            })
        })
        this.setState({
            students,
            teachers,
            boards,
            // data
            scount,
            data_st_1,
            data_st_2,
            data_st_3,
            options2,
            sSex, sAge, sLevel, sJoin, sJoin_number
        })
    }
    reQ = (name, func) => {

        // if(func===0){
        //     Firebase.firestore().collection('MOJ1S').where('Sex','==',name).onSnapshot(this.listdata);
        // }else if(func===1){
        //     Firebase.firestore().collection('MOJ1S').where('Age','==',name).onSnapshot(this.listdata);
        // }else if(func===2){
        //     Firebase.firestore().collection('MOJ1S').where('Level','==',name).onSnapshot(this.listdata);
        // }else if(func===3){
        //     Firebase.firestore().collection('MOJ1S').where('Join','==',name).onSnapshot(this.listdata);
        // }
        // this.setState({
        //     title_selected:name
        // })
    }

    render() {
        const { sSex, sAge, sLevel, sJoin, sJoin_number, scount, data_st_1, data_st_3 } = this.state;


        const optionsSex = {
            animationEnabled: true,
            exportEnabled: true,
            theme: "light1", // "light1", "dark1", "dark2"
            title: {
                text: 'เพศ',
                fontSize: 20
            },
            data: [{
                type: "pie",
                indexLabel: "{label}: {y}%",
                // startAngle: -10 ,
                // dataPoints: [
                //     { y: (sSex[0] * 100 / scount).toFixed(2), label: 'ชาย' },
                //     { y: (sSex[1] * 100 / scount).toFixed(2), label: 'หญิง' },
                // ]
                dataPoints: [
                    { y: 51.08, label: "Chrome" },
                    { y: 27.34, label: "Internet Explorer" },
                    { y: 10.62, label: "Firefox" },
                    { y: 5.02, label: "Microsoft Edge" },
                    { y: 4.07, label: "Safari" },
                    { y: 1.22, label: "Opera" },
                    { y: 0.44, label: "Others" }
                ]
            }]
        }
        const optionsAge = {
            animationEnabled: true,
            exportEnabled: true,
            theme: "light1", // "light1", "dark1", "dark2"
            title: {
                text: 'อายุ',
                fontSize: 20
            },
            data: [{
                type: "pie",
                indexLabel: "{label}: {y}%",
                // startAngle: -10 ,
                dataPoints: [
                    { y: (sAge[0] * 100 / scount).toFixed(2), label: '7 - 9 ปี' },
                    { y: (sAge[1] * 100 / scount).toFixed(2), label: '10 - 12 ปี' },
                    { y: (sAge[2] * 100 / scount).toFixed(2), label: '13 - 15 ปี' },
                    { y: (sAge[3] * 100 / scount).toFixed(2), label: '16 - 18 ปี' },
                ]
            }]
        }
        const optionsLevel = {
            animationEnabled: true,
            exportEnabled: true,
            theme: "light1", // "light1", "dark1", "dark2"
            title: {
                text: 'ระดับการศึกษา',
                fontSize: 20
            },
            data: [{
                type: "pie",
                indexLabel: "{label}: {y}%",
                // startAngle: -10 ,
                dataPoints: [
                    { y: (sLevel[1] * 100 / scount).toFixed(2), label: 'ประถมศึกษาปีที่ 4 – 6' },
                    { y: (sLevel[2] * 100 / scount).toFixed(2), label: 'มัธยมศึกษาปีที่ 1 – 3' },
                    { y: (sLevel[0] * 100 / scount).toFixed(2), label: 'ประถมศึกษาปีที่ 1 – 3' },
                    { y: (sLevel[3] * 100 / scount).toFixed(2), label: 'มัธยมศึกษาปีที่ 4 – 6' },
                ]
            }]
        }
        const optionsJoin = {
            animationEnabled: true,
            exportEnabled: true,
            theme: "light1", // "light1", "dark1", "dark2"
            title: {
                text: 'การเข้าร่วมโครงการ',
                fontSize: 20
            },
            data: [{
                type: "pie",
                indexLabel: "{label}: {y}%",
                // startAngle: -10 ,
                dataPoints: [
                    { y: (sJoin[0] * 100 / scount).toFixed(2), label: 'เคย' },
                    { y: (sJoin[1] * 100 / scount).toFixed(2), label: 'ไม่เคย' },
                ]
            }]
        }
        const optionsJoin_number = {
            animationEnabled: true,
            exportEnabled: true,
            theme: "light1", // "light1", "dark1", "dark2"
            title: {
                text: 'จำนวนการเข้าร่วมโครงการ',
                fontSize: 20
            },
            data: [{
                type: "pie",
                indexLabel: "{label}: {y}%",
                // startAngle: -10 ,
                dataPoints: [
                    { y: (sJoin_number[0] * 100 / this.state.sJoin[0]).toFixed(2), label: '1 ครั้ง' },
                    { y: (sJoin_number[1] * 100 / this.state.sJoin[0]).toFixed(2), label: '2 - 3 ครั้ง' },
                    { y: (sJoin_number[2] * 100 / this.state.sJoin[0]).toFixed(2), label: 'มากกว่า 3 ครั้ง' },
                ]
            }]
        }
        const options21 = {
            animationEnabled: true,
            exportEnabled: true,
            theme: "light1", // "light1", "dark1", "dark2"
            data: [{
                type: "pie",
                indexLabel: "{label}: {y}%",
                // startAngle: -10 ,
                dataPoints: [
                    { y: (data_st_1[0] * 100 / scount).toFixed(2), label: 'ดีมาก' },
                    { y: (data_st_1[1] * 100 / scount).toFixed(2), label: 'ดี' },
                    { y: (data_st_1[2] * 100 / scount).toFixed(2), label: 'พอใช้' },
                    { y: (data_st_1[3] * 100 / scount).toFixed(2), label: 'ต้องปรับปรุง' }
                ]
            }]
        }
        const options23 = {
            animationEnabled: true,
            exportEnabled: true,
            theme: "light1", // "light1", "dark1", "dark2"
            data: [{
                type: "pie",
                indexLabel: "{label}: {y}%",
                // startAngle: -10 ,
                dataPoints: [
                    { y: (data_st_3[0] * 100 / scount).toFixed(2), label: 'ดีมาก' },
                    { y: (data_st_3[1] * 100 / scount).toFixed(2), label: 'ดี' },
                    { y: (data_st_3[2] * 100 / scount).toFixed(2), label: 'พอใช้' },
                    { y: (data_st_3[3] * 100 / scount).toFixed(2), label: 'ต้องปรับปรุง' }
                ]
            }]
        }
        return (

            <div style={{ justifyContent: 'center' }}>
                <Row>
                    <p style={{ margin: 5 }}>ดาวน์โหลดเอกสาร excel</p>
                    <ExcelFile element={<button style={{ borderRadius: 10, margin: 5 }}>นักเรียน</button>}>
                        <ExcelSheet data={this.state.students} name="นักเรียน" >
                            <ExcelColumn label="ชื่อโรงเรียน" value="School_name" />
                            <ExcelColumn label="เพศ" value="Sex" />
                            <ExcelColumn label="อายุ" value="Age" />
                            <ExcelColumn label="ระดับการศึกษา" value="Level" />
                            <ExcelColumn label="การเข้าร่วม" value="Join" />
                            <ExcelColumn label="จำนวนการเข้าร่วม" value="Join_number" />
                            <ExcelColumn label="คะแนนส่วนส่วนที่ 2.1" value="Score1" />
                            <ExcelColumn label="คะแนนส่วนส่วนที่ 2.3" value="Score3" />
                        </ExcelSheet>
                    </ExcelFile>
                    <ExcelFile element={<button style={{ borderRadius: 10, margin: 5 }}>ครู</button>}>
                        <ExcelSheet data={this.state.teachers} name="ครู" >
                            <ExcelColumn label="ชื่อผู้สัมภาษณ์" value="QName" />
                            <ExcelColumn label="นามสกุลผู้สัมภาษณ์" value="QLast_name" />
                            <ExcelColumn label="วันที่ผู้สัมภาษณ์" value="QDate" />
                            <ExcelColumn label="เวลาผู้สัมภาษณ์" value="QTime" />
                            <ExcelColumn label="สถานที่ ที่ผู้สัมภาษณ์" value="QLocation" />
                            <ExcelColumn label="ชื่อผู้ถูกผู้สัมภาษณ์" value="AName" />
                            <ExcelColumn label="นามสกุลผู้ถูกผู้สัมภาษณ์" value="ALast_name" />
                            <ExcelColumn label="สถานะ" value="AStatus" />
                            <ExcelColumn label="ส่วนเกี่ยวข้องกับโครงการ" value="ADetail" />
                            <ExcelColumn label="1.ท่านคิดว่าโครงการโรงเรียนยุติธรรมอุปถัมภ์มีประโยชน์หรือไม่อย่างไร(โปรดอธิบาย)" value="Answer1" />
                            <ExcelColumn label="2. ภายหลังการเข้าร่วมกิจกรรมนักเรียนมีการเปลี่ยนแปลงพฤติกรรมไปในทางที่ดีขึ้น หรือไม่ อย่างไร(โปรดระบุการเปลี่ยนแปลงที่เกิดขึ้น)" value="Answer2" />
                            <ExcelColumn label="3. ท่านสามารถนำเนื้อหา กิจกรรม กระบวนการไปปรับใช้ในการจัดการเรียนการสอนได้หรือไม่อย่างไร(โปรดอธิบาย)" value="Answer3" />
                            <ExcelColumn label="4. โครงการโรงเรียนยุติธรรมอุปถัมภ์ควรมีการปรับปรุงเนื้อหากระบวนการวิธีการดำเนินกิจกรรมหรือไม่อย่างไร" value="Answer4" />
                        </ExcelSheet>
                    </ExcelFile>
                    <ExcelFile element={<button style={{ borderRadius: 10, margin: 5 }}>ผู้บริหาร</button>}>
                        <ExcelSheet data={this.state.boards} name="ผู้บริหาร" >
                            <ExcelColumn label="ชื่อผู้สัมภาษณ์" value="QName" />
                            <ExcelColumn label="นามสกุลผู้สัมภาษณ์" value="QLast_name" />
                            <ExcelColumn label="วันที่ผู้สัมภาษณ์" value="QDate" />
                            <ExcelColumn label="เวลาผู้สัมภาษณ์" value="QTime" />
                            <ExcelColumn label="สถานที่ ที่ผู้สัมภาษณ์" value="QLocation" />
                            <ExcelColumn label="ชื่อผู้ถูกผู้สัมภาษณ์" value="AName" />
                            <ExcelColumn label="นามสกุลผู้ถูกผู้สัมภาษณ์" value="ALast_name" />
                            <ExcelColumn label="สถานะ" value="AStatus" />
                            <ExcelColumn label="ส่วนเกี่ยวข้องกับโครงการ" value="ADetail" />
                            <ExcelColumn label="1. จากการที่นักเรียนในโรงเรียนเข้าร่วมกิจกรรมสร้างภูมิคุ้มให้เด็กและเยาวชนในโรงเรียนท่านเห็นความเปลี่ยนแปลงเกิดขึ้นหรือไม่ อย่างไร (โปรดอธิบาย)" value="Answer1" />
                            <ExcelColumn label="2. ท่านคิดว่าโครงการโรงเรียนยุติธรรมอุปถัมภ์เป็นประโยชน์ต่อการสร้างความตระหนักรู้ด้านการป้องกันอาชญากรรมและภัยทางสังคมแก่นักเรียนในโรงเรียนของท่านอย่างไร" value="Answer2" />
                            <ExcelColumn label="3. หลังจากที่โรงเรียนของท่านมีการจัดกิจกรรมภายใต้โครงการโรงเรียนยุติธรรมอุปถัมภ์โรงเรียนท่านมีมาตรการส่งเสริมความปลอดภัยในโรงเรียนอย่างไร" value="Answer3" />
                            <ExcelColumn label="4. ท่านมีข้อเสนอในเชิงนโยบายต่อการขับเคลื่อนงานตามแนวทางโรงเรียนยุติธรรมอุปถัมภ์อย่างไร" value="Answer4" />
                        </ExcelSheet>
                    </ExcelFile>
                    {/* <button type="button" style={{borderRadius:5}} onClick={()=>this.setState({step:1})}>นักเรียน</button> */}
                    {/* <button type="button" style={{borderRadius:5}} onClick={()=>this.setState({step:2})}>ครู</button>
                        <button type="button" style={{borderRadius:5}} onClick={()=>this.setState({step:3})}>ผู้บริหาร</button> */}
                </Row>
                <br></br>

                <div style={{ marginLeft: '3%' }}>

                    {/* <p>ประเภทการแสดงผล</p>
                        <Row>
                            <button type="button" style={{borderRadius:5,margin:5}} onClick={this.reQ.bind(this,'ทั้งหมด',0)}>ทั้งหมด</button>
                            <button type="button" style={{borderRadius:5,margin:5}} onClick={this.reQ.bind(this,'ชาย',1)}>ชาย</button>
                            <button type="button" style={{borderRadius:5,margin:5}} onClick={this.reQ.bind(this,'หญิง',1)}>หญิง</button>
                            <button type="button" style={{borderRadius:5,margin:5}} onClick={this.reQ.bind(this,'7 - 9 ปี',2)}>7 - 9 ปี</button>
                            <button type="button" style={{borderRadius:5,margin:5}} onClick={this.reQ.bind(this,'10 - 12 ปี',2)}>9 - 12 ปี</button>
                            <button type="button" style={{borderRadius:5,margin:5}} onClick={this.reQ.bind(this,'12 - 15 ปี',2)}>12 - 15 ปี</button>
                            <button type="button" style={{borderRadius:5,margin:5}} onClick={this.reQ.bind(this,'16 - 18 ปี',2)}>16 - 18 ปี</button>
                            <button type="button" style={{borderRadius:5,margin:5}} onClick={this.reQ.bind(this,'ประถมศึกษาปีที่ 1 – 3',3)}>ป. 1 - 3</button>
                            <button type="button" style={{borderRadius:5,margin:5}} onClick={this.reQ.bind(this,'ประถมศึกษาปีที่ 4 – 6',3)}>ป. 4 - 6</button>
                            <button type="button" style={{borderRadius:5,margin:5}} onClick={this.reQ.bind(this,'มัธยมศึกษาปีที่   1 – 3',3)}>ม. 1 - 3</button>
                            <button type="button" style={{borderRadius:5,margin:5}} onClick={this.reQ.bind(this,'มัธยมศึกษาปีที่   4 – 6',3)}>ม. 4 - 6</button>
                            <button type="button" style={{borderRadius:5,margin:5}} onClick={this.reQ.bind(this,'เคย',4)}>เคยร่วมโครงการ</button>
                            <button type="button" style={{borderRadius:5,margin:5}} onClick={this.reQ.bind(this,'ไม่เคย',4)}>ไม่เคยร่วมโครงการ</button>
                            <button type="button" style={{borderRadius:5,margin:5}} onClick={this.reQ.bind(this,'1 ครั้ง',4)}>เคยร่วมโครงการ 1 ครั้ง</button>
                            <button type="button" style={{borderRadius:5,margin:5}} onClick={this.reQ.bind(this,'2 - 3 ครั้ง',4)}>เคยร่วมโครงการ 2 - 3 ครั้ง</button>
                            <button type="button" style={{borderRadius:5,margin:5}} onClick={this.reQ.bind(this,'มากกว่า 3 ครั้ง',4)}>เคยร่วมโครงการมากกว่า 3 ครั้ง</button>   
                        </Row> */}
                    {/* นักเรียน */}
                    <div style={{ justifyContent: 'center' }}>
                        <p style={{ fontSize: 20, textAlign: 'center' }}><strong>จำนวนนักเรียนตอบแบบสอบถาม {this.state.scount}</strong></p>

                        {console.log("นักเรียน", this.state.students.length)}
                        {console.log("นักเรียน", this.state.students)}
                        <p style={{ fontSize: 20, textAlign: 'center' }}><strong>จำนวนครูตอบแบบสอบถาม {this.state.teachers.length}</strong></p>
                        {console.log("ครู", this.state.teachers.length)}
                        <p style={{ fontSize: 20, textAlign: 'center' }}><strong>จำนวนผู้บริหารตอบแบบสอบถาม {this.state.boards.length}</strong></p>
                        {console.log("ผู้บริหาร", this.state.boards.length)}
                        <p style={{ fontSize: 20, textAlign: 'center' }}><strong>ส่วนที่ 1 ข้อมูลทั่วไปของผู้ตอบแบบสอบถาม</strong></p>
                    </div>

                    {/* <p style={{fontSize:20}}><strong>ประเภทการแสดงผลที่เลือก{this.state.title_selected}</strong></p> */}
                    <Row>
                        <div style={{ width: '50%' }}>
                            <CanvasJSChart options={optionsSex} />
                        </div>
                        <div style={{ width: '50%' }}>
                            <CanvasJSChart options={optionsAge} />
                        </div>
                    </Row>
                    <Row>
                        <div style={{ width: '50%' }}>
                            <CanvasJSChart options={optionsLevel} />
                        </div>
                        <div style={{ width: '50%' }}>
                            <CanvasJSChart options={optionsJoin} />
                        </div>
                    </Row>
                    <Row>
                        <div style={{ width: '50%', flex: 1, justifyContent: 'center' }}>
                            <CanvasJSChart options={optionsJoin_number} />
                        </div>
                    </Row>
                    <br></br>
                    <div style={{ justifyContent: 'center' }}>
                        <p style={{ fontSize: 20, textAlign: 'center' }}><strong>ส่วนที่ 2 : การประเมินผลนักเรียนที่เข้าร่วมกิจกรรมภายใต้โครงการโรงเรียนยุติธรรมอุปถัมภ์</strong></p>
                        <p style={{ fontSize: 20, textAlign: 'center' }}><strong>2.1 ประเมินผลการเรียนรู้ของนักเรียนที่เข้าร่วมกิจกรรมภายใต้โครงการโรงเรียนยุติธรรมอุปถัมภ์</strong></p>
                    </div>
                    <Row>
                        <div style={{ width: '50%', flex: 1, justifyContent: 'center' }}>
                            <CanvasJSChart options={options21} />
                        </div>
                    </Row>
                    <div style={{ justifyContent: 'center' }}>
                        <p style={{ fontSize: 20, textAlign: 'center' }}><strong>2.2 ประเมินผลความเหมาะสมนักเรียนหลังการเข้าร่วมกิจกรรมภายใต้โครงการโรงเรียนยุติธรรมอุปถัมภ์</strong></p>
                    </div>
                    {this.state.options2.map((element, i) =>
                        // console.log(element)
                        <div key={i} style={{ width: '100%' }}>
                            {i == 0 ?
                                <div style={{ width: '50%', marginTop: 20, textAlign: 'center', display: 'contents' }}>
                                    <hr style={{ width: '60%' }}></hr>
                                    <h4><strong>ด้านกระบวนการและรูปแบบการดำเนินกิจกรรม</strong></h4>
                                    <p>ส่วนเบี่ยงเบนมาตรฐาน :  {this.state.stdtitle1}</p>
                                    <p>ค่าเฉลี่ย : {this.state.title1}</p>
                                    <hr style={{ width: '60%' }}></hr>
                                    <Row>
                                        <div style={{ width: '100%', }}>
                                            <CanvasJSChart options={this.state.gdata21} />
                                        </div>
                                    </Row>
                                </div>
                                : <div></div>
                            }
                            {i == 5 ?
                                <div style={{ width: '50%', marginTop: 20, textAlign: 'center', display: 'contents' }}>
                                    <hr style={{ width: '60%' }}></hr>
                                    <h4><strong>ด้านเนื้อหาและสื่อที่ใช้ประกอบ</strong></h4>
                                    <p>ส่วนเบี่ยงเบนมาตรฐาน :  {this.state.stdtitle2}</p>
                                    <p>ค่าเฉลี่ย : {this.state.title2}</p>
                                    <Row>
                                        <div style={{ width: '100%', }}>
                                            <CanvasJSChart options={this.state.gdata22} />
                                        </div>
                                    </Row>
                                    <hr style={{ width: '60%' }}></hr>

                                </div>
                                : <div></div>
                            }
                            {i == 10 ?
                                <div style={{ width: '50%', marginTop: 20, textAlign: 'center', display: 'contents' }}>
                                    <hr style={{ width: '60%' }}></hr>
                                    <h4><strong>ด้านความเหมาะสมของการดำเนินกิจกรรมม</strong></h4>
                                    <p>ส่วนเบี่ยงเบนมาตรฐาน :  {this.state.stdtitle3}</p>
                                    <p>ค่าเฉลี่ย : {this.state.title3}</p>
                                    <Row>
                                        <div style={{ width: '100%', }}>
                                            <CanvasJSChart options={this.state.gdata23} />
                                        </div>
                                    </Row>
                                    <hr style={{ width: '60%' }}></hr>
                                </div>
                                : <div></div>

                            }
                            {/* <Row>
                                <div style={{ width: '50%', }}>
                                    <CanvasJSChart options={element.gdata} />
                                </div>
                                <div style={{ width: '50%', marginTop: 20 }}>
                                    <p>ส่วนเบี่ยงเบนมาตรฐาน :  {element.data.std}</p>
                                    <p>ค่าเฉลี่ย : {element.data.av}</p>
                                </div>
                            </Row> */}
                            {i == 14 ?
                                <div style={{ width: '50%', marginTop: 20, textAlign: 'center', display: 'contents' }}>
                                    <hr style={{ width: '60%' }}></hr>
                                    <h4><strong>ประมวลผลข้อมูลส่วนที่ 2.2</strong></h4>
                                    <p>ส่วนเบี่ยงเบนมาตรฐาน :  {this.state.result22.std}</p>
                                    <p>ค่าเฉลี่ย : {this.state.result22.av}</p>
                                    <Row>
                                        <div style={{ width: '100%', }}>
                                            <CanvasJSChart options={this.state.result22.gdata} />
                                        </div>
                                    </Row>
                                    <hr style={{ width: '60%' }}></hr>
                                </div>
                                : <div></div>

                            }
                        </div>
                    )}

                    <div style={{ justifyContent: 'center' }}>
                        <p style={{ fontSize: 20, textAlign: 'center' }}><strong>2.3 ประเมินผลความเหมาะสมนักเรียนหลังการเข้าร่วมกิจกรรมภายใต้โครงการโรงเรียนยุติธรรมอุปถัมภ์</strong></p>
                    </div>
                    <Row>
                        <div style={{ width: '50%', flex: 1, justifyContent: 'center' }}>
                            <CanvasJSChart options={options23} />
                        </div>
                    </Row>


                </div>

            </div>
        )
    }
}

export default Result

